module.exports = __webpack_public_path__ + "static/media/ceci-fernandes.40d036ef.png";